import { Product, PRODUCTS } from "data/data";
import { FC, Fragment, useEffect, useState } from "react";
import { Dialog, Popover, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from "react-router-dom";
import Item from "./Item";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Basketervice from "app/services/basketService";
import Button from "shared/Button/Button";

export interface BasketProps {
    id: number;
    price: number;
    product: Product;
    quantity: number;
 
}

const Basket = () =>{
    const [open, setOpen] = useState<boolean>(false)
    const [items, setItems] = useState<BasketProps[]>([])
    const [nbItems, setNbItems] = useState<number>()
    const [totalPrice, setTotalPrice] = useState<number>()
    const basketHndeler = () => {
        setOpen(true)
    }

    useEffect(() => {
        Basketervice.get().then(data => {
            if (!data.detail){
                console.log(data)
                setItems(data)
                setNbItems(data.length)
                const s = data.reduce((n:any, item:any) => n = item.price  +n , 0)
                setTotalPrice(s)
            }
            
        }).catch(r => {
            // console.log(r)
        })
    }, [open])

    return (
        <Popover>
                    <Popover.Button
                    onClick={basketHndeler}
            className={`
                
                 group w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full inline-flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 relative`}
          >
            <div className="w-3.5 h-3.5 flex items-center justify-center bg-primary-500 absolute top-1.5 right-1.5 rounded-full text-[10px] leading-none text-white font-medium">
              
              {
                nbItems ? <span className="mt-[1px]">{nbItems}</span> : null
              } 
            </div>
            <svg
              className="w-6 h-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 2H3.74001C4.82001 2 5.67 2.93 5.58 4L4.75 13.96C4.61 15.59 5.89999 16.99 7.53999 16.99H18.19C19.63 16.99 20.89 15.81 21 14.38L21.54 6.88C21.66 5.22 20.4 3.87 18.73 3.87H5.82001"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.25 22C16.9404 22 17.5 21.4404 17.5 20.75C17.5 20.0596 16.9404 19.5 16.25 19.5C15.5596 19.5 15 20.0596 15 20.75C15 21.4404 15.5596 22 16.25 22Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.25 22C8.94036 22 9.5 21.4404 9.5 20.75C9.5 20.0596 8.94036 19.5 8.25 19.5C7.55964 19.5 7 20.0596 7 20.75C7 21.4404 7.55964 22 8.25 22Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 8H21"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            {/* <Link className="block md:hidden absolute inset-0" to={"/cart"} /> */}
          </Popover.Button>
            <Transition.Root show={open} as={Fragment}>
        
                <Dialog as="div" className="relative z-40 " onClose={setOpen}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className=" fixed inset-0 overflow-hidden ">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10  ">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <Dialog.Panel className="pointer-events-auto w-screen max-w-md  ">
                            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl dark:bg-slate-900 text-slate-900 dark:text-slate-200">
                                <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                <div className="flex items-start justify-between">
                                    <Dialog.Title className="text-lg font-medium text-gray-900  dark:text-slate-200">Shopping cart</Dialog.Title>
                                    <div className="ml-3 flex h-7 items-center">
                                    <button
                                        type="button"
                                        className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Close panel</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                    </div>
                                </div>

                                <div className="mt-8">
                                    <div className="flow-root">
                                    <ul role="list" className="-my-6 divide-y divide-gray-200">
                                  
                                        {items.map(
                                                (item, index) => Item(item, index, ()=>{ setOpen(false)})
                                        )}
                                    </ul>
                                    </div>
                                </div>
                                </div>

                                <div className="border-t border-gray-200 px-4 py-6 sm:px-6">
                                <div className="flex justify-between text-base font-medium text-gray-900">
                                    <p>Total</p>
                                    <p>{totalPrice} DZD</p>
                                </div>
                                <p className="mt-0.5 text-sm text-gray-500">Frais de port et taxes calculés à la caisse.</p>
                                <div className="mt-6">
                                    
                                    <Link
                                        to="/dash/checkout"
                                        onClick={()=> setOpen(false)}
                                       
                                    >
                                        <Button  className=" ttnc-ButtonPrimary disabled:bg-opacity-90 bg-slate-900 dark:bg-slate-100 hover:bg-slate-800 text-slate-50 dark:text-slate-800 shadow-xl flex w-full">
                                        Checkout
                                        </Button>
                                    </Link>
                                    
                                    
                                </div>
                         
                             
                                </div>
                            </div>
                            </Dialog.Panel>
                        </Transition.Child>
                        </div>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Popover>
    )
}

export default  Basket;